import { vTooltip } from 'floating-vue';

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp
    .directive('focus', {
      mounted(el, { value = 'input' }) {
        el.querySelectorAll(value)?.[0]?.focus();
      }
    })
    .directive('tooltip', vTooltip);
});
